import {
  GET_EMAIL_CONFIGS,
  GET_ORGANIZATION_EMAIL_CONFIGS,
  ADD_EMAIL_CONFIG,
  REMOVE_EMAIL_CONFIG,
  CREATE_EMAIL_CONFIG,
  UPDATE_EMAIL_CONFIG,
  DELETE_EMAIL_CONFIG,
} from '../actions/emailConfigActions';


const initialState = {
  emailConfig: {
    loading: false,
    loaded: true,
    account: '',
    imap_username: '',
    imap_host: '',
    imap_port: null,
    email: '',
    smtp_username: '',
    smtp_sender_name: '',
    smtp_host: '',
    total_number_of_emails_per_day: '',
    campaigns_used_on: '',
    created_date: '',
    delay_between_each_email_sent: null,
  },
  emailConfigs: {
    loading: false,
    loaded: true,
    results: [],
  },
};


export const emailConfigReducer = (state = initialState.emailConfig, action) => {
  switch (action.type) {
    case CREATE_EMAIL_CONFIG.pending:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_EMAIL_CONFIG.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_EMAIL_CONFIG.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_EMAIL_CONFIG.pending:
      return {
        loading: true,
        loaded: false,
      };
    case UPDATE_EMAIL_CONFIG.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_EMAIL_CONFIG.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case DELETE_EMAIL_CONFIG.pending:
      return {
        loading: true,
        loaded: false,
      };
    case DELETE_EMAIL_CONFIG.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case DELETE_EMAIL_CONFIG.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};


export const emailConfigsReducer = (state = initialState.emailConfigs, action) => {
  switch (action.type) {
    case GET_EMAIL_CONFIGS.pending:
      return {
        loading: true,
        loaded: false,
        ...state,
      };
    case GET_EMAIL_CONFIGS.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_EMAIL_CONFIGS.success:
      if (action.payload.data.results) {
        return {
          loading: false,
          loaded: true,
          ...action.payload.data,
        };
      }
      return {
        loading: false,
        loaded: true,
        results: action.payload.data,
      };
    default:
      return state;
  }
};

export const organizationEmailConfigsReducer = (state = initialState.emailConfigs, action) => {
  switch (action.type) {
    case GET_ORGANIZATION_EMAIL_CONFIGS.pending:
      return {
        loading: true,
        loaded: false,
        ...state,
      };
    case GET_ORGANIZATION_EMAIL_CONFIGS.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_ORGANIZATION_EMAIL_CONFIGS.success:
      return {
        loading: false,
        loaded: true,
        results: action.payload.data,
      };
    case ADD_EMAIL_CONFIG.pending:
      return {
        loading: true,
        loaded: false,
        ...state,
      };
    case ADD_EMAIL_CONFIG.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case ADD_EMAIL_CONFIG.success:
      return {
        loading: false,
        loaded: true,
        results: state.results.filter(emailConfig => emailConfig.id !== action.payload.data.id),
      };
    case REMOVE_EMAIL_CONFIG.pending:
      return {
        loading: true,
        loaded: false,
        ...state,
      };
    case REMOVE_EMAIL_CONFIG.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case REMOVE_EMAIL_CONFIG.success:
      return {
        loading: false,
        loaded: true,
        results: state.results,
      };
    default:
      return state;
  }
};
